import { Check, AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import usePutData from "../../../../CustomHooks/useAxios/usePutData";
import { ACTIVATE_CYLINDER } from "../../../../api/allApi_List";
import Modal from "../../../../components/portal/Modal";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";
import { handleErrMessage } from "../../../../functions/handleErrMessage";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";

const ActiveCylinderDialog = ({ cylinderDetails, setSelectedCylinder }) => {
  const navigate = useNavigate();
  const { executePut, loading, formError, setFormError, successResponse } =
    usePutData();

  const { reason, cylinderNo, cylinderId } = cylinderDetails;

  const cylinderActivate = () => {
    executePut(`${ACTIVATE_CYLINDER}${cylinderId}`, {});
  };

  const handleClose = () => {
    if (loading) return;
    if (successResponse) {
      navigate(0);
    } else {
      setSelectedCylinder(null);
    }
  };

  return (
    <Modal onClose={handleClose} closeIcon modalWidth="w-[95%] max-w-md">
      <div className="p-3 md:p-5 space-y-5">
        {/* ERROR */}
        {formError && (
          <ErrorDisplay
            message={handleErrMessage(formError)}
            closeAction={() => setFormError("")}
          />
        )}

        {/* SUCCESS STATE */}
        {successResponse ? (
          <div className="flex flex-col items-center text-center space-y-2 py-6">
            <Check className="text-green-3" size={28} strokeWidth={3} />
            <h3 className="text-lg font-semibold text-green-3">
              Cylinder No. {cylinderNo} Activated
            </h3>
            <p className="text-sm text-gray-500">
              The cylinder has been successfully activated.
            </p>
          </div>
        ) : (
          <>
            {/* HEADER */}
            <div className="flex items-start gap-1 md:gap-3">
              <div className="bg-yellow-100 p-2 rounded-full">
                <AlertTriangle className="text-yellow-600" size={20} />
              </div>
              
              <div>
                <h2 className="md:text-lg font-semibold text-gray-800">
                  Enable Cylinder
                </h2>
                <p className="text-sm text-gray-500">
                  Are you sure you want to enable this cylinder?
                </p>
              </div>
            </div>

            {/* CYLINDER DETAILS CARD */}
            <div className="border-blue-200 border-2 rounded-xl p-2 md:p-4 bg-gray-50 space-y-2 text-sm">
              <p className="text-sm text-gray-500">
                Cylinder No: <span className="text-gray-900">{cylinderNo}</span>
              </p>
              <div className="pt-1">
                <p className="text-sm text-gray-500">Reason</p>
                <p className="text-gray-700">{reason}</p>
              </div>
            </div>

            {/* ACTIONS */}
            <div className="flex justify-end gap-2 pt-3">
              <GrayButton btnText="Cancel" onClick={handleClose} />

              <button
                disabled={loading}
                onClick={cylinderActivate}
                className="bg-teal-600 hover:bg-teal-500 px-4 py-[3px] text-white rounded-lg text-sm hover:text-white transition"
              >
                {!loading ? "Enable" : "Activating..."}
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ActiveCylinderDialog;
